import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SVG from '../Atoms/SVG'
import i18n from '../../../Utils/I18nUtil'
import variables from '../../../../config/variables'

const GeneratorFooter = ({labelColor, showSubline = false}) => {
    return (
        <Wrapper color={labelColor}>
            <CenterContainer>
                <InlineBlock>
                    <Icons>
                        <SVG icon={'lock'}/>
                    </Icons>
                    <TextContainer>
                        {i18n('footer.label.safety_hint')}
                    </TextContainer>
                </InlineBlock>
            </CenterContainer>
            {showSubline &&
                <SubLine>
                    {i18n('footer.label.powered_by')}&nbsp;
                    <A href={variables.poweredByUrl} target={'_blank'}>passwort <b>generator</b></A>
                </SubLine>}
        </Wrapper>
    )
}

GeneratorFooter.propTypes = {
    labelColor: PropTypes.string,
    showSubline: PropTypes.bool,
}

export default GeneratorFooter

const CenterContainer = styled.div`
    text-align: center;
`

const Wrapper = styled.div`
    color: ${props => props.color ? props.color : 'black'};
    font-size: 10px;
`

const InlineBlock = styled.div`
    display: inline-block;
    text-align: left;
    max-width: 350px;
`

const Icons = styled.div`
    float: left;
    height: 40px;
    padding-right: 5px;
    svg {
        height: 30px;   
        margin-top: 5px;
        margin-right: -5px;
    }
`

const TextContainer = styled.div`
    padding-top: 5px;
`

const SubLine = styled.div`
    margin-top: 20px;
`

const A = styled.a`
    color: #0b436a;
    text-decoration: none;
    font-style: italic;
    &:hover {
        text-decoration: underline;
    }
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Organisms/GeneratorFooter.jsx